import { event, string } from "../schema-util";

import { noProps, projectId, reportId } from "./shared";

export const report = {
  "Create report.Report.Report panel": event({
    projectId,
  }).describe("User clicked on the Create Report button in the Report panel on a project"),
  "Create multi report.MultiReport.MultiReport panel": event({ projectId }),
  "MultiReport.Create.MultiReport Created": event({ projectId, multiReportId: string() }).describe("The multiproject report was created"),
  "MultiReport.Create.MultiReport Generated": event({ reportId: string() }).describe("The multiproject report was generated for the first time"),

  "Report.Cost.Changed cost map layers visibility": noProps,
  "Report.Cost.Cost map cost type toggled": noProps,
  "Report.Cost.Cost Viewed": event({ reportId }),
  "Report.Cost.Downloaded cost chart": noProps,
  "Report.Cost.Exported via datagrid": noProps,
  "Report.Cost.Map zoom in": noProps,
  "Report.Cost.Map zoom out": noProps,

  // TODO: refactor to use a single event with attributes
  // only 28 events by non-biarri users over the last year
  "Report.Cost.Filtering datagrid by ID": noProps,
  "Report.Cost.Filtering datagrid by Category": noProps,
  "Report.Cost.Filtering datagrid by Tag": noProps,
  "Report.Cost.Filtering datagrid by Cost": noProps,
  "Report.Cost.Filtering datagrid by Cost Bins": noProps,

  "Report.Create.Report Created": event({ reportId }).describe("The report was created"),
  "Report.Create.Report Generated": event({ reportId }).describe("The report was generated for the first time"),
  "Report.Delete.Deleted report": event({ reportId }),
  "Report.Import.Report Imported": event({ reportId }),
  "Report.Move.Moved report": event({ reportId }),
  "Report.Overview.Overview viewed": event({ reportId }),
  "Report.Report Row.Renamed report": event({ reportId }).describe("User renamed a report in the project/report list"),
  "Report.ReportName.Renamed report": event({ reportId }).describe("User renamed a report from the report name top-bar field"),
  "Report.Revenue.Changed build map layers visibility": noProps.describe("User moved the slider on the build map"),
  "Report.Revenue.Downloaded revenue chart": noProps,
  "Report.Revenue.Exported via datagrid": noProps,
  "Report.Revenue.Revenue viewed": event({ reportId }),
  "Report.Settings.Report re-generated": event({ reportId }),
};
